import { aboutPrivacyAndCookiePolicyUrl } from 'mk2/apps/about/urls';
import { Route } from 'mk2/containers/Application/Application';

export const routes: Route[] = [
    {
        app: 'about',
        exact: true,
        path: aboutPrivacyAndCookiePolicyUrl,
        getPage: () => {
            return import('mk2/apps/about/containers/PrivacyAndCookiePolicy/PrivacyAndCookiePolicyPage' /* webpackChunkName: "about.PrivacyAndCookiePolicy" */);
        },
        modules: ['mk2/apps/about/containers/PrivacyAndCookiePolicy/PrivacyAndCookiePolicyPage'],
    },
];
